import { createMuiTheme } from '@material-ui/core/styles';

//const blue = "#0B72B9";
const blue = "#0B72B9";
const blue2 = "#71c2f9";
//const lightBlue = "#4bccfd";
//const green = "#4dce70";

//const orange = "#FFBA60";
const orange = "#FFBA60";
const orange2 = "#f48d46";

//const gray = "#868686";
const black = "#101010";

const bgGrad1 = `linear-gradient(to right,${orange} , ${orange2})`;
const bgGrad2 = `linear-gradient(to right, ${orange2}, ${orange})`;
const bgGrad3 = `linear-gradient(to right, ${blue2}, ${blue}  50%)`;
const theme = createMuiTheme({
    palette: {
        common: {
            blue: `${blue}`,
            orange: `${orange}`,
            bgGrad1: `${bgGrad1}`,
            bgGrad2: `${bgGrad2}`,
            bgGrad3: `${bgGrad3}`
        },
        primary: {
            main: `${blue}`
        },
        secondary: {
            main: `${orange}`
        }
    },
    typography: {
        fontFamily: [
            'IRANSans',
            'Helvetica',
            'sans-serif',
        ].join(','),
        tab: {
            textTransform: "none",
            fontWeight: 700,
            color: "white",
            fontSize: "1rem",
        },
        estimate: {
            fontSize: "1rem",
            textTransform: "none",
            color: "white"
        },
        h2: {
            fontWeight: 700,
            fontSize: "2.5rem",
            color: blue,
            lineHeight: 1.5
        },
        h3: {
            fontSize: "2.5rem",
            color: blue
        },
        h4: {
            fontSize: "1.75rem",
            color: blue,
            fontWeight: 700,
        },
        h6: {
            color: blue,
            fontWeight: 500,
            lineHeight: 1
        },
        subtitle1: {
            fontSize: "1.25rem",
            fontWeight: 300,
            color: `${black}`
        },
        subtitle2: {
            color: "white",
            fontSize: "1.25rem",
            fontWeight: 300
        },
        body1: {
            fontSize: "1.25rem",
            color: `${black}`,
            fontWeight: 300
        },
        caption: {
            fontSize: "1rem",
            fontWeight: 300,
            color: black
        },
        learnButton: {
            borderColor: blue,
            color: blue,
            borderWidth: 2,
            textTransform: "none",
            //borderRadius: 50,
            fontWeight: "bold"
        }
    },
    overrides: {
        MuiInputLabel: {
            root: {
                color: blue,
                fontSize: "1rem"
            }
        },
        MuiInput: {
            root: {
                color: black,
                fontWeight: 300
            },
            underline: {
                "&:before": {
                    borderBottom: `2px solid ${blue}`
                },
                "&:hover:not($disabled):not($focused):not($error):before": {
                    borderBottom: `2px solid ${blue}`
                },
            }
        }
    }
})

export default theme;